import AddBrandModule from '@/modules/brand/add-brand';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
  type: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/brand/add-brand/')({
  validateSearch: searchSchema,
  component: AddBrandPage,
});

function AddBrandPage() {
  return <AddBrandModule />;
}
